import * as React from "react";
import { Create, SimpleForm, TextInput, required, SelectInput } from 'react-admin';

export const UserCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <TextInput disabled label="Identifiant" source="id" />
            <TextInput label="Nom" source="lastName" validate={required()} />
            <TextInput label="Prénom" source="firstName" validate={required()} />
            <TextInput label="Email" source="email" validate={required()} />
            <TextInput label="Mot de passe" source="password" validate={required()} />
            <SelectInput source="role" choices={[
                { id: 'SuperAdmin', name: 'SuperAdmin' },
                { id: 'Admin', name: 'Admin' },
                { id: 'SEO', name: 'SEO' },
            ]} />

        </SimpleForm>
    </Create>
);